import { render, staticRenderFns } from "./confirmation-modal.vue?vue&type=template&id=5412d482&scoped=true&"
import script from "./confirmation-modal.vue?vue&type=script&lang=js&"
export * from "./confirmation-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412d482",
  null
  
)

export default component.exports